module.exports = __webpack_public_path__ + "img/xth.7dd0fd75.jpg";